import React from 'react';
import { Section } from './ui/Section';
export function ProblemSection() {
  return <Section background="white" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <h2 className="text-3xl font-serif font-bold text-warm-dark mb-8 text-center" data-id="element-155">
          Te pasa así...
        </h2>

        <div className="space-y-6 text-lg text-warm-gray leading-relaxed" data-id="element-156">
          <p data-id="element-157">
            En la mañana estás bien. Incluso motivada. Te dices:{' '}
            <span className="text-terracotta font-medium" data-id="element-158">"hoy sí"</span>.
          </p>

          <p data-id="element-159">Pero llega la tarde… y algo cambia.</p>

          <div className="bg-cream p-6 rounded-2xl border-l-4 border-terracotta my-8" data-id="element-160">
            <p className="font-medium text-warm-dark italic" data-id="element-161">
              A las 3pm te da ese bajón raro: cansancio + ansiedad + "solo algo
              dulce". Y en la noche… terminas picando lo que sea porque ya no te
              queda batería.
            </p>
          </div>

          <p data-id="element-162">
            Y lo peor no es lo que comes. Es la conversación que viene después:
          </p>

          <p className="text-center font-bold text-warm-dark text-xl" data-id="element-163">
            "¿Por qué no puedo controlarme?"
          </p>

          <p data-id="element-164">
            No es falta de disciplina. Es que estás intentando ganar un juego
            sin reglas.
          </p>
        </div>
      </div>
    </Section>;
}